import React, { useEffect } from 'react';
import Modal from '../global/modal';
import { Configuration } from '$/core';
import './index.scss';

const CutoverToCreditSights: React.FC = () => {
  const creditSightsUrl: string = Configuration.creditSightsUrl;
  const cutoverLimit: number = Configuration.cutoverLimit;
  const cutoverSeconds = cutoverLimit * 1000; // Convert seconds to milliseconds

  // This modal needs to automatically redirect the user to Configurations.creditSightsUrl after x number of seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = creditSightsUrl;
    }, cutoverSeconds);

    return () => clearTimeout(timer);
  }, [creditSightsUrl, cutoverSeconds]);

  return (
    <>
      <Modal active={true} wideView={false} forForm={false} hideClose={true}>
        <div>
          <p>
            <strong>We're now part of CreditSights</strong>
          </p>
          <p>
            We're excited to announce that Bixby has been fully integrated into CreditSights, enhancing your research
            experience.
          </p>
          {/* <p>
              What's New:
              <ul>
                <li>Benefit 1</li>
                <li>Benefit 2</li>
                <li>Benefit 3</li>
              </ul>
            </p> */}
          <p>Don't worry, all your saved research and preferences have been transfered</p>
          <p>
            <a className="link_underline" href={creditSightsUrl}>
              Continue to CreditSights
            </a>
          </p>
        </div>
      </Modal>
    </>
  );
};

export default CutoverToCreditSights;
